module.exports = __webpack_public_path__ + "img/img_案例08.704c0878.png";